
















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'settings-row' })
export default class SettingsRow extends Vue {
    @Prop({ type: String, default: 'default' })
    type!: string

    @Prop({ type: Boolean, default: false })
    fullWidth!: boolean
}
